/* eslint-disable */
export default {
  removeMeetingWarning: '排程功能已停用。請使用 {app} 排程視訊會議。',
  scheduleMeetingTips:
    '請注意，我們已將會議從此應用程式中移除。若要使用會議，建議您使用 {app}。',
  migrateToPluginAlert:
    '注意：此應用程式不支援 Outlook 2016 及更低版本以及 Internet Explorer 11。請升級您的 Outlook 或切換到 Microsoft Edge，亦可切換到 {app}',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
